import { Outlet } from 'react-router-dom'
import Navbar from './Navbar'
import Sidebar from './Sidebar'

function UserLayout() {
  return (
    <>
      <div className='LoggedInContainer'>
        <Navbar />
        <Sidebar />
        <div className='mainContent'>
          <Outlet />
        </div>
      </div>
    </>
  )
}

export default UserLayout
